// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Costs_wrapper__5bd8O","item":"Costs_item__2zdvt","title":"Costs_title__3Jd8o","desc":"Costs_desc__ZaRkl","italic":"Costs_italic__1tH9L","rooming":"Costs_rooming__1MO-T"};